import { call, takeLatest } from "redux-saga/effects";
import * as billingApis from "../apis/billingApis"
import { CUSTOMERS_DROPDOWN, EXPORT_REPORT, GENERATE_BILL, PRODUCT_DROPDOWN, TRANSACTIONS_LIST } from "../actions/types";


export function* generateBillWorker(action) {
    try {
        const res = yield call(billingApis.generateBillApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* listBillingWorker(action) {
    try {
        const res = yield call(billingApis.listBillingApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* productDropdownWorker(action) {
    try {
        const res = yield call(billingApis.productDropdownApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* exportReportWorker(action) {
    try {
        const res = yield call(billingApis.exportReportApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* customersDropdownWorker(action) {
    try {
        const res = yield call(billingApis.customersDropdownApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* listBillingWatcher() {
    yield takeLatest(TRANSACTIONS_LIST, listBillingWorker);
}
export function* generateBillWatcher() {
    yield takeLatest(GENERATE_BILL, generateBillWorker);
}
export function* productDropdownWatcher() {
    yield takeLatest(PRODUCT_DROPDOWN, productDropdownWorker);
}
export function* exportReportWatcher() {
    yield takeLatest(EXPORT_REPORT, exportReportWorker);
}
export function* customersDropdownWatcher() {
    yield takeLatest(CUSTOMERS_DROPDOWN, customersDropdownWorker);
}